import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const CustomerQueries = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        গ্রাহক জিজ্ঞাসা
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1">
          এখানে গ্রাহকদের জিজ্ঞাসা এবং প্রশ্নাবলী দেখানো হবে।
        </Typography>
      </Paper>
    </Box>
  );
};

export default CustomerQueries; 